/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "./google/protobuf/timestamp";
import { Account } from "./account";
import {
  Error,
  ErrorResponse,
  ProvisionedURLResponse,
  IdRequest,
  QueryRequest,
  EmptyRequest,
  ProvisionAttachmentRequest,
} from "./base";

export const protobufPackage = "traverse";

export interface User {
  id: number;
  created: Date | undefined;
  updated: Date | undefined;
  deleted: Date | undefined;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  account: Account | undefined;
  roles: User_Role[];
  emailVerified: boolean;
  completedTutorial: boolean;
  presignedCDCCredentialURL: string;
  totpEnabled: boolean;
  hasStripeCustomerRecord: boolean;
}

export enum User_Role {
  None = 0,
  Observer = 1,
  Reporting = 2,
  AccountHolder = 3,
  TraverseAdmin = 4,
  TraverseNurse = 5,
  UNRECOGNIZED = -1,
}

export function user_RoleFromJSON(object: any): User_Role {
  switch (object) {
    case 0:
    case "None":
      return User_Role.None;
    case 1:
    case "Observer":
      return User_Role.Observer;
    case 2:
    case "Reporting":
      return User_Role.Reporting;
    case 3:
    case "AccountHolder":
      return User_Role.AccountHolder;
    case 4:
    case "TraverseAdmin":
      return User_Role.TraverseAdmin;
    case 5:
    case "TraverseNurse":
      return User_Role.TraverseNurse;
    case -1:
    case "UNRECOGNIZED":
    default:
      return User_Role.UNRECOGNIZED;
  }
}

export function user_RoleToJSON(object: User_Role): string {
  switch (object) {
    case User_Role.None:
      return "None";
    case User_Role.Observer:
      return "Observer";
    case User_Role.Reporting:
      return "Reporting";
    case User_Role.AccountHolder:
      return "AccountHolder";
    case User_Role.TraverseAdmin:
      return "TraverseAdmin";
    case User_Role.TraverseNurse:
      return "TraverseNurse";
    default:
      return "UNKNOWN";
  }
}

export interface UserRequest {
  token: string;
  user: User | undefined;
}

export interface UserResponse {
  error: Error | undefined;
  User: User | undefined;
}

export interface UserListResponse {
  error: Error | undefined;
  Users: User[];
}

const baseUser: object = {
  id: 0,
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  roles: 0,
  emailVerified: false,
  completedTutorial: false,
  presignedCDCCredentialURL: "",
  totpEnabled: false,
  hasStripeCustomerRecord: false,
};

export const User = {
  encode(message: User, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.created !== undefined) {
      Timestamp.encode(
        toTimestamp(message.created),
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.updated !== undefined) {
      Timestamp.encode(
        toTimestamp(message.updated),
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.deleted !== undefined) {
      Timestamp.encode(
        toTimestamp(message.deleted),
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.firstName !== "") {
      writer.uint32(42).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(98).string(message.lastName);
    }
    if (message.email !== "") {
      writer.uint32(50).string(message.email);
    }
    if (message.phoneNumber !== "") {
      writer.uint32(58).string(message.phoneNumber);
    }
    if (message.account !== undefined) {
      Account.encode(message.account, writer.uint32(74).fork()).ldelim();
    }
    writer.uint32(82).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.emailVerified === true) {
      writer.uint32(88).bool(message.emailVerified);
    }
    if (message.completedTutorial === true) {
      writer.uint32(104).bool(message.completedTutorial);
    }
    if (message.presignedCDCCredentialURL !== "") {
      writer.uint32(130).string(message.presignedCDCCredentialURL);
    }
    if (message.totpEnabled === true) {
      writer.uint32(136).bool(message.totpEnabled);
    }
    if (message.hasStripeCustomerRecord === true) {
      writer.uint32(144).bool(message.hasStripeCustomerRecord);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): User {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseUser } as User;
    message.roles = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = longToNumber(reader.int64() as Long);
          break;
        case 2:
          message.created = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 3:
          message.updated = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 4:
          message.deleted = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 5:
          message.firstName = reader.string();
          break;
        case 12:
          message.lastName = reader.string();
          break;
        case 6:
          message.email = reader.string();
          break;
        case 7:
          message.phoneNumber = reader.string();
          break;
        case 9:
          message.account = Account.decode(reader, reader.uint32());
          break;
        case 10:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }
          } else {
            message.roles.push(reader.int32() as any);
          }
          break;
        case 11:
          message.emailVerified = reader.bool();
          break;
        case 13:
          message.completedTutorial = reader.bool();
          break;
        case 16:
          message.presignedCDCCredentialURL = reader.string();
          break;
        case 17:
          message.totpEnabled = reader.bool();
          break;
        case 18:
          message.hasStripeCustomerRecord = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): User {
    const message = { ...baseUser } as User;
    message.id =
      object.id !== undefined && object.id !== null ? Number(object.id) : 0;
    message.created =
      object.created !== undefined && object.created !== null
        ? fromJsonTimestamp(object.created)
        : undefined;
    message.updated =
      object.updated !== undefined && object.updated !== null
        ? fromJsonTimestamp(object.updated)
        : undefined;
    message.deleted =
      object.deleted !== undefined && object.deleted !== null
        ? fromJsonTimestamp(object.deleted)
        : undefined;
    message.firstName =
      object.firstName !== undefined && object.firstName !== null
        ? String(object.firstName)
        : "";
    message.lastName =
      object.lastName !== undefined && object.lastName !== null
        ? String(object.lastName)
        : "";
    message.email =
      object.email !== undefined && object.email !== null
        ? String(object.email)
        : "";
    message.phoneNumber =
      object.phoneNumber !== undefined && object.phoneNumber !== null
        ? String(object.phoneNumber)
        : "";
    message.account =
      object.account !== undefined && object.account !== null
        ? Account.fromJSON(object.account)
        : undefined;
    message.roles = (object.roles ?? []).map((e: any) => user_RoleFromJSON(e));
    message.emailVerified =
      object.emailVerified !== undefined && object.emailVerified !== null
        ? Boolean(object.emailVerified)
        : false;
    message.completedTutorial =
      object.completedTutorial !== undefined &&
      object.completedTutorial !== null
        ? Boolean(object.completedTutorial)
        : false;
    message.presignedCDCCredentialURL =
      object.presignedCDCCredentialURL !== undefined &&
      object.presignedCDCCredentialURL !== null
        ? String(object.presignedCDCCredentialURL)
        : "";
    message.totpEnabled =
      object.totpEnabled !== undefined && object.totpEnabled !== null
        ? Boolean(object.totpEnabled)
        : false;
    message.hasStripeCustomerRecord =
      object.hasStripeCustomerRecord !== undefined &&
      object.hasStripeCustomerRecord !== null
        ? Boolean(object.hasStripeCustomerRecord)
        : false;
    return message;
  },

  toJSON(message: User): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.created !== undefined &&
      (obj.created = message.created.toISOString());
    message.updated !== undefined &&
      (obj.updated = message.updated.toISOString());
    message.deleted !== undefined &&
      (obj.deleted = message.deleted.toISOString());
    message.firstName !== undefined && (obj.firstName = message.firstName);
    message.lastName !== undefined && (obj.lastName = message.lastName);
    message.email !== undefined && (obj.email = message.email);
    message.phoneNumber !== undefined &&
      (obj.phoneNumber = message.phoneNumber);
    message.account !== undefined &&
      (obj.account = message.account
        ? Account.toJSON(message.account)
        : undefined);
    if (message.roles) {
      obj.roles = message.roles.map((e) => user_RoleToJSON(e));
    } else {
      obj.roles = [];
    }
    message.emailVerified !== undefined &&
      (obj.emailVerified = message.emailVerified);
    message.completedTutorial !== undefined &&
      (obj.completedTutorial = message.completedTutorial);
    message.presignedCDCCredentialURL !== undefined &&
      (obj.presignedCDCCredentialURL = message.presignedCDCCredentialURL);
    message.totpEnabled !== undefined &&
      (obj.totpEnabled = message.totpEnabled);
    message.hasStripeCustomerRecord !== undefined &&
      (obj.hasStripeCustomerRecord = message.hasStripeCustomerRecord);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<User>, I>>(object: I): User {
    const message = { ...baseUser } as User;
    message.id = object.id ?? 0;
    message.created = object.created ?? undefined;
    message.updated = object.updated ?? undefined;
    message.deleted = object.deleted ?? undefined;
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.email = object.email ?? "";
    message.phoneNumber = object.phoneNumber ?? "";
    message.account =
      object.account !== undefined && object.account !== null
        ? Account.fromPartial(object.account)
        : undefined;
    message.roles = object.roles?.map((e) => e) || [];
    message.emailVerified = object.emailVerified ?? false;
    message.completedTutorial = object.completedTutorial ?? false;
    message.presignedCDCCredentialURL = object.presignedCDCCredentialURL ?? "";
    message.totpEnabled = object.totpEnabled ?? false;
    message.hasStripeCustomerRecord = object.hasStripeCustomerRecord ?? false;
    return message;
  },
};

const baseUserRequest: object = { token: "" };

export const UserRequest = {
  encode(
    message: UserRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseUserRequest } as UserRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.user = User.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UserRequest {
    const message = { ...baseUserRequest } as UserRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.user =
      object.user !== undefined && object.user !== null
        ? User.fromJSON(object.user)
        : undefined;
    return message;
  },

  toJSON(message: UserRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.user !== undefined &&
      (obj.user = message.user ? User.toJSON(message.user) : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<UserRequest>, I>>(
    object: I
  ): UserRequest {
    const message = { ...baseUserRequest } as UserRequest;
    message.token = object.token ?? "";
    message.user =
      object.user !== undefined && object.user !== null
        ? User.fromPartial(object.user)
        : undefined;
    return message;
  },
};

const baseUserResponse: object = {};

export const UserResponse = {
  encode(
    message: UserResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.User !== undefined) {
      User.encode(message.User, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseUserResponse } as UserResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.User = User.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UserResponse {
    const message = { ...baseUserResponse } as UserResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.User =
      object.User !== undefined && object.User !== null
        ? User.fromJSON(object.User)
        : undefined;
    return message;
  },

  toJSON(message: UserResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    message.User !== undefined &&
      (obj.User = message.User ? User.toJSON(message.User) : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<UserResponse>, I>>(
    object: I
  ): UserResponse {
    const message = { ...baseUserResponse } as UserResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.User =
      object.User !== undefined && object.User !== null
        ? User.fromPartial(object.User)
        : undefined;
    return message;
  },
};

const baseUserListResponse: object = {};

export const UserListResponse = {
  encode(
    message: UserListResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.Users) {
      User.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserListResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseUserListResponse } as UserListResponse;
    message.Users = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.Users.push(User.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UserListResponse {
    const message = { ...baseUserListResponse } as UserListResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.Users = (object.Users ?? []).map((e: any) => User.fromJSON(e));
    return message;
  },

  toJSON(message: UserListResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    if (message.Users) {
      obj.Users = message.Users.map((e) => (e ? User.toJSON(e) : undefined));
    } else {
      obj.Users = [];
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<UserListResponse>, I>>(
    object: I
  ): UserListResponse {
    const message = { ...baseUserListResponse } as UserListResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.Users = object.Users?.map((e) => User.fromPartial(e)) || [];
    return message;
  },
};

export interface UserService {
  GetUsersInAccount(request: IdRequest): Promise<UserListResponse>;
  GetUser(request: IdRequest): Promise<UserResponse>;
  GetUsers(request: QueryRequest): Promise<UserListResponse>;
  GetUsersAwaitingCDCApproval(request: QueryRequest): Promise<UserListResponse>;
  UpdateUser(request: UserRequest): Promise<UserResponse>;
  DeleteUser(request: IdRequest): Promise<ErrorResponse>;
  FinishedTutorial(request: EmptyRequest): Promise<ErrorResponse>;
  ProvisionCDCUpload(
    request: ProvisionAttachmentRequest
  ): Promise<ProvisionedURLResponse>;
  AcceptCDCDocument(request: IdRequest): Promise<ErrorResponse>;
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >;

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000;
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = t.seconds * 1_000;
  millis += t.nanos / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
